import { DeclarationsListVM } from 'civil-status/view-models/research-form-icaro';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<DeclarationsListVM, keyof DeclarationsListVM>[] = [
  {
    id: 'surnameName',
    label: 'Cognome/Nome nato',
  },
  {
    id: 'twins',
    label: 'Gem.',
  },
  {
    id: 'dateBorn',
    label: 'Data di nascita',
  },
  {
    id: 'numberDeclaration',
    label: 'Num. dichiarazione',
  },
  {
    id: 'dateDeclaration',
    label: 'Data dichiarazione',
  },
  {
    id: 'hospital',
    label: 'Ospedale',
  },
  {
    id: 'dateArrive',
    label: 'Data arrivo',
  },
  {
    id: 'state',
    label: 'Stato dichiarazione',
  },
  {
    id: 'idAnsc',
    label: 'Atto ANSC',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
